export const GET_ABOUT_PAGE_DATA = 'GET_ABOUT_PAGE_DATA';
export const ABOUT_PAGE_DATA_LOADED = 'ABOUT_PAGE_DATA_LOADED';
export const ABOUT_PAGE_DATA_LOAD_FAILED = 'ABOUT_PAGE_DATA_LOAD_FAILED';